import { CommonPaginator, usePaginated } from './usePaginated'
import { CheckoutClosing } from 'depoto-core'
import { useCallback, useMemo } from 'react'
import { removeEmptyProperties } from '../'
import { useCore } from '../../hooks'

// !+!+!+!+!+!+!+!+!+!+
// Module was moved from RN Terminal
// Please do not remove unknown and "unused" functions.
// !+!+!+!+!+!+!+!+!+!+

export type CheckoutClosingsFilters = Partial<{
  checkouts?: number[]
  companies?: number[]
}>

const clientFilterKeys = []

interface Params {
  filters?: CheckoutClosingsFilters
  sort?: string
  direction?: string
  schema?: any
}

export function usePaginatedCheckoutClosings(params: Params = {}) {
  const { filters, schema = { id: null }, sort = 'id', direction = 'DESC' } = params
  const { core } = useCore()

  const serverFilters = useMemo(
    () =>
      removeEmptyProperties(
        Object.fromEntries(Object.entries(filters || {}).filter(([key]) => !clientFilterKeys.includes(key))),
      ),
    [filters],
  )

  const fetchCheckoutClosings = useCallback(
    async (page: number) => {
      const params: any = removeEmptyProperties({
        direction,
        filters: serverFilters,
        page,
        sort: sort,
      })

      return (await core.services.checkout.getCheckoutClosingList(params, schema)) as {
        items: CheckoutClosing[]
        paginator: CommonPaginator
      }
    },
    [core.services.checkout, serverFilters, sort],
  )

  const {
    isLastPage,
    loadMore,
    loading,
    refresh,
    items: checkoutClosings,
    totalCount,
  } = usePaginated<CheckoutClosing>({
    queryKey: ['checkoutClosings', filters, sort, direction],
    fetchItems: fetchCheckoutClosings,
  })

  return {
    isLastPage,
    loadMore,
    loading,
    checkoutClosings,
    refresh,
    totalCount,
  }
}
